import React, { useEffect, useState } from 'react';
import EDLinkListItem from '../../../../BaseComponents/List/LinkList/EDLinkListItem';
import { rutinRouteName } from '../../../../Features/Routing/router';
import EDLinkList from '../../../../BaseComponents/List/LinkList/EDLinkList';
import EDHighlightedText from '../../../../BaseComponents/Autocomplete/Components/EDHighlightedText';
import { IRutinMatch } from './DelsystemView';
import { withStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import {
  currentRoutingVersion,
  System,
  useBaseRouteValue,
} from '../../../../Features/Routing/Utils/routerUtils';
import DeliveryStatusTag from '../../../DeliveryStatusTag/DeliveryStatusTag';

interface IProps {
  databaseName: string;
  system: System | null;
  routineMatches: IRutinMatch[];
  show: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    flexDirection: 'row-reverse',
    paddingLeft: theme.spacing(7.25),
  },
});

const RutinList: React.FC<React.PropsWithChildren<IProps>> = props => {
  const [shouldRender, setShouldRender] = useState(false);
  const { databasePath, systemPath, usernamePath } = useBaseRouteValue();
  useEffect(() => {
    if (!shouldRender && props.show) {
      setShouldRender(true);
    }
  }, [shouldRender, setShouldRender, props.show]);

  return !shouldRender ? null : (
    <EDLinkList>
      {props.routineMatches.map(match => (
        <EDLinkListItem
          key={match.rutinInfo.rutinID}
          to={`/${currentRoutingVersion}/${systemPath}/${usernamePath}/${databasePath}/${rutinRouteName}/${match.rutinInfo.rutinURL}`}
          text={<EDHighlightedText parts={match.parts} />}
          typographyProps={{ variant: 'body2' }}
          testId={match.rutinInfo.rutinURL}
          icon={
            match.rutinInfo.leveransstatus !== 'Active' ? (
              <DeliveryStatusTag
                leveransstatus={match.rutinInfo.leveransstatus}
              />
            ) : undefined
          }
          classes={{
            listItem: props.classes.root,
          }}
        />
      ))}
    </EDLinkList>
  );
};

export default withStyles(RutinList, styles);
